// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 32) return "static/js/ff47927bc3a8c19d5020.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"9a996e302bc7c0d599c8","137":"689fb60b35373bd80508","138":"933ee5fbfbaaaf237d40"}[chunkId] + ".chunk.js";
};